import { chakra, Text } from '@chakra-ui/react';

export const Keyword = chakra(Text, {
  baseStyle: {
    fontWeight: 'bold',
    paddingRight: 2,
    '&:not(:last-child):after': { content: '","', fontWeight: 'normal', textDecoration: 'none' },
  },
});
